import { Icon } from "../Icon";
import { Text } from "../Text";

export function CompactionEntry() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 4,
        height: 28,
        padding: "6px 10px 6px 8px",
      }}
    >
      <Icon name="shrink" size={12} color="var(--text-secondary)" />
      <Text variant="text-small" color="var(--text-secondary)">
        Conversation compacted
      </Text>
    </div>
  );
}
